export default {
  id: 216,
  title: 'Target #216 - Pies',
  url: 'https://cssbattle.dev/play/216',
  colors: ['#37212D', '#EE9B99', '#BCE6E9', '#76608A'],
  solution:
    '<p a><p b><p c><p d><style>p[a],p[b]{width:240}p[b],p[c]{left:80;border-radius:9in 9in 0 0}p[a],p[b],p[d]{top:90;height:120}body{background:#37212d}p{position:fixed;margin:0}p[a]{left:80;background:linear-gradient(90deg,#76608a 120px,#ee9b99 120px)}p[b]{background:linear-gradient(90deg,#ee9b99 120px,#bce6e9 120px)}p[c]{top:150;width:120;height:60;background:#bce6e9}p[d]{left:200;width:60;background:#76608a;border-radius:0 9in 9in 0',
}
